export default __webpack_public_path__ + "static/default-e8a037bb277049a98eea095742e949bc.png";